import React from "react";
import { StyledLinkedinCard } from "./LinkedinCard.styled";
import { BodyTyp } from "../../../../../../components/Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../../../../../types/AppTypes";
import { ReactComponent as LinkedinIcon } from "../../../../../../icons/linkedin.svg";
import { ReactComponent as AddIcon } from "../../../../../../icons/add.svg";
import { ReactComponent as EditIcon } from "../../../../../../icons/pencil.svg";
import { IconManager } from "../../../../../../components/core/IconManager/IconManager";
import {
  ADD_LINKEDIN_LABEL,
  EMPTY_STRING,
  LINKEDIN_LABEL,
} from "../../../../../../constants/Dictionary";
import { LinkedinModal } from "./LinkedinModal/LinkedinModal";
import { theme } from "../../../../../../constants/StyledComponents";
import {
  Link,
  LinkSizeEnum,
} from "../../../../../../components/core/Link/Link";
import { StyledLinkedinCardIconContainer } from "../ProfessionalPortait.styled";
import { canEditCollaboratorHistory } from "../../../../../../utils/canEditCollaboratorHistory.utils";
import { useAppSelector } from "../../../../../../hooks/store.hook";
import {
  CollaboratorCmSheet,
  CollaboratorDetails,
} from "../../../../../../types/api/collaborators.type";

type LinkedinCardProps = {
  currentCmSheet?: CollaboratorCmSheet;
  collaborator: CollaboratorDetails;
  profileUrl?: string;
  professionalDataId?: number;
  isMyProfile?: boolean;
  onUpdate?: () => void;
  isEditable?: boolean;
};

const LinkedinCard: React.FC<LinkedinCardProps> = ({
  currentCmSheet,
  collaborator,
  profileUrl,
  professionalDataId,
  isMyProfile,
  onUpdate,
  isEditable,
}) => {
  const { profile } = useAppSelector((state) => state.user);
  const [showAddModal, setShowAddModal] = React.useState(false);

  const handleSave = () => {
    setShowAddModal(false);
    onUpdate?.();
  };

  const canEditHistory = canEditCollaboratorHistory(
    profile,
    collaborator,
    currentCmSheet,
    isMyProfile,
  );

  return (
    <>
      <StyledLinkedinCard>
        <div className="linkedin-card-header">
          <StyledLinkedinCardIconContainer
            {...(profileUrl && {
              onClick: () => window.open(profileUrl, "_blank"),
            })}
          >
            <IconManager
              size={IconSizeEnum.MEDIUM}
              fill={theme.colors.black}
              noStrokeColor
            >
              <LinkedinIcon />
            </IconManager>
          </StyledLinkedinCardIconContainer>
          {profileUrl ? (
            <Link size={LinkSizeEnum.SMALL} target="_blank" href={profileUrl}>
              {LINKEDIN_LABEL}
            </Link>
          ) : canEditHistory ? (
            <BodyTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
              {ADD_LINKEDIN_LABEL}
            </BodyTyp>
          ) : (
            <BodyTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
              {EMPTY_STRING}
            </BodyTyp>
          )}
        </div>
        {canEditHistory && (
          <div>
            {profileUrl ? (
              <IconManager
                size={IconSizeEnum.MEDIUM}
                onClick={() => setShowAddModal(true)}
              >
                {isEditable && <EditIcon />}
              </IconManager>
            ) : (
              <IconManager
                size={IconSizeEnum.MEDIUM}
                onClick={() => setShowAddModal(true)}
              >
                <AddIcon />
              </IconManager>
            )}
          </div>
        )}
      </StyledLinkedinCard>
      {showAddModal && (
        <LinkedinModal
          isOpen={showAddModal}
          onClose={() => setShowAddModal(false)}
          onSave={handleSave}
          linkedInUrl={profileUrl}
          professionalDataId={professionalDataId}
          collaborator={collaborator}
        />
      )}
    </>
  );
};

export default LinkedinCard;
